import React from "react"
import { Link } from "gatsby"
import "./footer.css"

import { LazyLoadImage } from "react-lazy-load-image-component"
import "react-lazy-load-image-component/src/effects/blur.css"

import UIOM from "../../images/UIOM.png"

const footer = () => (
	<div className="footer-dark">
		<footer>
			<div className="container text-center">
				<Link to="/uiom">
					<LazyLoadImage
						src={UIOM}
						alt="UIOM"
						className="img-fluid"
						effect="blur"
					/>
				</Link>
				<p className="mt-4">
					<Link className="register" to="/uiom">
						LEARN MORE
					</Link>
				</p>

				{/*<p className="text-white-50 copyright mt-5">
					Designed and powered by
					<a
						href="https://webriq.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						{" "}
						WebriQ
					</a>
				</p>*/}
			</div>
		</footer>
	</div>
)

export default footer
